export const TEACHER_SALARY_REQUEST = "TEACHER_SALARY_REQUEST";
export const TEACHER_SALARY_SUCCESS = "TEACHER_SALARY_SUCCESS";
export const TEACHER_SALARY_FAIL = "TEACHER_SALARY_FAIL";
export const TEACHER_SALARY_RESET = "TEACHER_SALARY_RESET";

export const TEACHER_REGISTER_REQUEST = "TEACHER_REGISTER_REQUEST";
export const TEACHER_REGISTER_SUCCESS = "TEACHER_REGISTER_SUCCESS";
export const TEACHER_REGISTER_FAIL = "TEACHER_REGISTER_FAIL";
export const TEACHER_REGISTER_RESET = "TEACHER_REGISTER_RESET";

export const TEACHER_DELETE_REQUEST = "TEACHER_DELETE_REQUEST";
export const TEACHER_DELETE_SUCCESS = "TEACHER_DELETE_SUCCESS";
export const TEACHER_DELETE_FAIL = "TEACHER_DELETE_FAIL";
export const TEACHER_DELETE_RESET = "TEACHER_DELETE_RESET";

export const TEACHER_UPDATE_REQUEST = "TEACHER_UPDATE_REQUEST";
export const TEACHER_UPDATE_SUCCESS = "TEACHER_UPDATE_SUCCESS";
export const TEACHER_UPDATE_FAIL = "TEACHER_UPDATE_FAIL";

export const TEACHER_LIST_REQUEST = "TEACHER_LIST_REQUEST";
export const TEACHER_LIST_SUCCESS = "TEACHER_LIST_SUCCESS";
export const TEACHER_LIST_FAIL = "TEACHER_LIST_FAIL";
export const TEACHER_LIST_RESET = "TEACHER_LIST_RESET";

export const TEACHER_SEARCH_REQUEST = "TEACHER_SEARCH_REQUEST";
export const TEACHER_SEARCH_SUCCESS = "TEACHER_SEARCH_SUCCESS";
export const TEACHER_SEARCH_FAIL = "TEACHER_SEARCH_FAIL";

export const TEACHER_ATTENDANCE_REQUEST = "TEACHER_ATTENDANCE_REQUEST";
export const TEACHER_ATTENDANCE_SUCCESS = "TEACHER_ATTENDANCE_SUCCESS";
export const TEACHER_ATTENDANCE_FAIL = "TEACHER_ATTENDANCE_FAIL";
export const TEACHER_ATTENDANCE_RESET = "TEACHER_ATTENDANCE_RESET";
